import React from "react";
import { Settings } from "lucide-react";
import { useSelector } from "react-redux";
import { Tooltip } from "react-tooltip";

const SettingsTab = ({ mainTabs, activeTab, onItemClick }) => {
  const userModuleRights =
    useSelector((state) => state.userAuth.userinfo.userModuleRights) ?? {};

  const settingsTab = mainTabs?.find((tab) => tab.title === "Settings");
  const canAccessSettings =
    settingsTab && (userModuleRights[settingsTab.navigationName] ?? false);

  if (!settingsTab || !canAccessSettings) return null;

  const isActive = activeTab === settingsTab.key;

  const handleOpenSettings = () => {
    onItemClick(
      settingsTab.key,
      settingsTab.name,
      settingsTab.right,
      settingsTab.text,
      settingsTab.data,
    );
  };

  return (
    <>
      <Tooltip id="settings" />
      <div
        role="button"
        data-tooltip-id="settings"
        data-tooltip-content="Settings"
        data-tooltip-place="bottom"
        tabIndex={0}
        aria-label="Open settings"
        onClick={handleOpenSettings}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleOpenSettings();
          }
        }}
        className={`inline-flex h-8 w-8 items-center justify-center rounded-md outline-none transition-colors duration-150 ${isActive
          ? "text-[#7567f8]"
          : "text-[#889AB3] hover:bg-[#F3F4F7] hover:text-[#404D60]"
          }`}
      >
        <Settings size={16} strokeWidth={1.7} />
      </div>
    </>

  );
};

export default SettingsTab;